import { SkeletonBox } from 'components/skeletonBox';
import styles from './BannerHero.module.scss';

export const BannerHeroSkeleton = () => {
  return <SkeletonBox className={styles.skeleton} noPaddingTop noPaddingBottom />;
};
